import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../competitive/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME,ACCESS_Role_ID,ACCESS_Log_In_User_Id } from '../../../constants/apiConstants';
import axios from 'axios';

function CompetitiveCreateRole() {
    const [role, setRole] = useState("");
    const [title, setTitle] = useState("");
    const [status, setStatus] = useState("");
    const [participatingColleges, setParticipatingColleges] = useState("");
    const [pdcet, setPdcet] = useState("");
    const [examDate, setExamDate] = useState("");
    const [examLevel, setExamLevel] = useState("");
    const [applicationProcess, setApplicationProcess] = useState("");
    const [examInfo, setExamInfo] = useState("");

    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        
        const payload = {
            // "role_id": role,
            // "user_id": title,
            // "status": status,
            "pdcet": role,
            "participating_colleges": participatingColleges,
            "exam_date": examDate,
            "exam_level": examLevel,
            "application_process": applicationProcess,
            "exam_info": examInfo,
        };

        console.log("1111111111111111111111",payload)
        // return false
    
        const headers = {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`, 
            "Content-Type": "application/json",
        };
    
        axios.post(`${API_BASE_URL}/createCompetitiveExamsData`, payload, { headers })
            .then((response) => {
                console.log("222222222222",response)
                if (response.status === 200) {                   
                    navigate("/admin/competitiveListRole");
                } else {
                    console.error("Error: Unexpected response status", response.status);
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
            });
    };

    return (
        <>
            <div>
                <Header />
                <div className="main-container">
                    <AdminNavbar />
                    <div className="main">
                        <div className="report-container">
                            <div className="report-header">
                                <h1 className="recent-Articles">Create Competitive Exam</h1>
                            </div>
                            <div className="report-body">
                                <div className="user-form">
                                    <form onSubmit={handleSubmit}>

                                        {/* Competitive Exam Title */}
                                        {/* <div className="mb-3">
                                            <label htmlFor="title" className="form-label">
                                                Competitive Exam Title
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="title" 
                                                name="title" 
                                                value={title} 
                                                onChange={(e) => setTitle(e.target.value)}
                                            />
                                        </div> */}

                                        {/* Competitive Exam Name */}
                                        <div className="mb-3">
                                            <label htmlFor="role_name" className="form-label">
                                                Competitive Exam Name
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="role_name" 
                                                name="role_name" 
                                                value={role} 
                                                onChange={(e) => setRole(e.target.value)}
                                            />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label htmlFor="participating_colleges" className="form-label">
                                            PDCET
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="pdcet" 
                                                name="pdcet" 
                                                value={participatingColleges} 
                                                onChange={(e) => setParticipatingColleges(e.target.value)}
                                            />
                                        </div> */}
                                        {/* Participating Colleges */}
                                        <div className="mb-3">
                                            <label htmlFor="participating_colleges" className="form-label">
                                                Participating Colleges
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="participating_colleges" 
                                                name="participating_colleges" 
                                                value={participatingColleges} 
                                                onChange={(e) => setParticipatingColleges(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Date */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_date" className="form-label">
                                                Exam Date
                                            </label>
                                            <input 
                                                type="date" 
                                                className="form-control"
                                                id="exam_date" 
                                                name="exam_date" 
                                                value={examDate} 
                                                onChange={(e) => setExamDate(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Level */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_level" className="form-label">
                                                Exam Level
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control"
                                                id="exam_level" 
                                                name="exam_level" 
                                                value={examLevel} 
                                                onChange={(e) => setExamLevel(e.target.value)}
                                            />
                                        </div>

                                        {/* Application Process */}
                                        <div className="mb-3">
                                            <label htmlFor="application_process" className="form-label">
                                                Application Process
                                            </label>
                                            <textarea 
                                                className="form-control"
                                                id="application_process" 
                                                name="application_process" 
                                                value={applicationProcess} 
                                                onChange={(e) => setApplicationProcess(e.target.value)}
                                            />
                                        </div>

                                        {/* Exam Info */}
                                        <div className="mb-3">
                                            <label htmlFor="exam_info" className="form-label">
                                                Exam Info
                                            </label>
                                            <textarea 
                                                className="form-control"
                                                id="exam_info" 
                                                name="exam_info" 
                                                value={examInfo} 
                                                onChange={(e) => setExamInfo(e.target.value)}
                                            />
                                        </div>

                                        {/* Competitive Exam Status */}
                                        <div className="mb-3 mt-3">
                                            <label htmlFor="status" className="form-label">
                                                Competitive Exam Status
                                            </label>
                                            <select 
                                                className="form-control" 
                                                id="status" 
                                                value={status} 
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>

                                        <button type="submit" className="btn btn-primary submit-btn">
                                            CREATE
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompetitiveCreateRole;
